/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CellStatusFromJSON, CellStatusToJSON } from './';
export function UpdateCellRequestFromJSON(json) {
    return UpdateCellRequestFromJSONTyped(json, false);
}
export function UpdateCellRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        value: !exists(json, 'value') ? undefined : json['value'],
        description: !exists(json, 'description') ? undefined : json['description'],
        jsonData: !exists(json, 'jsonData') ? undefined : json['jsonData'],
        date: !exists(json, 'date') ? undefined : json['date'] === null ? null : new Date(json['date']),
        status: !exists(json, 'status') ? undefined : CellStatusFromJSON(json['status']),
        uniqueId: !exists(json, 'uniqueId') ? undefined : json['uniqueId'],
        importJobId: !exists(json, 'importJobId') ? undefined : json['importJobId'],
        tagIds: json['tagIds'],
    };
}
export function UpdateCellRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        value: value.value,
        description: value.description,
        jsonData: value.jsonData,
        date: value.date === undefined ? undefined : value.date === null ? null : value.date.toISOString().substr(0, 10),
        status: CellStatusToJSON(value.status),
        uniqueId: value.uniqueId,
        importJobId: value.importJobId,
        tagIds: value.tagIds,
    };
}
